import { useCallback, useState } from 'react';
import ExcelExportDialog from './ExcelExportDialog';
import { useGridExportRegistryOptional } from './GridExportContext';
import { showAlert } from 'utils/toastBridge';

/**
 * 페이지 툴바용 엑셀(F11) 액션 + 다이얼로그
 */
export function useExcelExportAction({ fileName = 'grid_export' } = {}) {
  const [open, setOpen] = useState(false);
  const registry = useGridExportRegistryOptional();

  const openDialog = useCallback(() => {
    if (!registry) {
      showAlert('엑셀 내보내기를 사용할 수 없습니다. (GridExportProvider 필요)', 'warning');
      return;
    }
    if (!registry.list().length) {
      showAlert('내보낼 그리드가 등록되어 있지 않습니다.', 'warning');
      return;
    }
    setOpen(true);
  }, [registry]);

  const excelButton = {
    id: 'excel',
    label: '엑셀',
    icon: '📊',
    hotkey: 'F11',
    onClick: openDialog,
  };

  const dialog = registry ? (
    <ExcelExportDialog
      open={open}
      onClose={() => setOpen(false)}
      fileName={fileName}
    />
  ) : null;

  return { openDialog, excelButton, dialog };
}
